@if (dataLoader) {
  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
    @for (i of [1, 2, 3, 4, 5]; track i) {
      <div class="h-40 animate-pulse rounded-xl border border-gray-100 bg-gray-100"></div>
    }
  </div>
} @else {
  @if (error) {
    <div class="mb-3 flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">
      <mat-icon class="!text-base">error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>
  }
  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
    <!-- 1. E-Services -->
    <div class="relative flex flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <div class="absolute inset-x-0 top-0 h-[3px] rounded-t-xl" [style.background]="'#0891b2'"></div>
      <div class="flex items-center gap-2 px-4 pt-2">
        <span class="text-base font-bold text-gray-700">E-Services</span>
      </div>
      <div class="flex flex-col divide-y divide-gray-50 px-4 pb-1">
        @for (es of eservices; track es.name) {
          <a
            class="flex items-center gap-2 text-gray-600 transition hover:text-primary"
            [routerLink]="es.queryParams.type === 'DV' ? '/eservices/owner-kyc' : '/eservices/list'"
            [queryParams]="es.queryParams"
          >
            <mat-icon class="icon-size-4" [ngClass]="es.color" [fontIcon]="es.icon"></mat-icon>
            <span class="flex-1 truncate text-sm">{{ es.name }}</span>
            <span class="text-base font-bold text-gray-900">{{ es.count | number }}</span>
            <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
          </a>
        } @empty {
          <div class="py-2 text-center text-sm text-gray-400">No pending e-services</div>
        }
      </div>
    </div>

    <!-- 2. Happiness Center -->
    <div class="relative flex flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <div class="absolute inset-x-0 top-0 h-[3px] rounded-t-xl" [style.background]="'#16a34a'"></div>
      <div class="flex items-center gap-2 px-4 pt-2">
        <span class="text-base font-bold text-gray-700">Happiness Center</span>
      </div>
      <div class="flex flex-col divide-y divide-gray-50 px-4 pb-1">
        <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/happiness-center/online" [queryParams]="{ _ref: 'dashboard', user_id: profile?.id }">
          <mat-icon class="text-green-500 icon-size-4" fontIcon="headset_mic"></mat-icon>
          <span class="flex-1 truncate text-sm">Online</span>
          <span [class]="'shrink-0 rounded-full px-0.5 text-xs font-semibold ' + ('info' | badge)">Online Tickets</span>
          <span class="text-base font-bold text-gray-900">{{ happinessCenterOnline | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
        @if (canViewCallCenter) {
          <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/happiness-center/call-center" [queryParams]="{ status: 'Hold' }">
            <mat-icon class="text-orange-400 icon-size-4" fontIcon="schedule"></mat-icon>
            <span class="flex-1 truncate text-sm">Hold</span>
            <span [class]="'shrink-0 rounded-full px-0.5 text-xs font-semibold ' + ('info' | badge)">Call Center</span>
            <span class="text-base font-bold text-gray-900">{{ callCenter.Hold | number }}</span>
            <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
          </a>
          <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/happiness-center/call-center" [queryParams]="{ status: 'In-Process' }">
            <mat-icon class="text-blue-400 icon-size-4" fontIcon="handyman"></mat-icon>
            <span class="flex-1 truncate text-sm">In Process</span>
            <span [class]="'shrink-0 rounded-full px-0.5 text-xs font-semibold ' + ('info' | badge)">Call Center</span>
            <span class="text-base font-bold text-gray-900">{{ callCenter.InProcess | number }}</span>
            <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
          </a>
          <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/happiness-center/call-center" [queryParams]="{ status: 'Open' }">
            <mat-icon class="text-green-400 icon-size-4" fontIcon="folder_open"></mat-icon>
            <span class="flex-1 truncate text-sm">Open</span>
            <span [class]="'shrink-0 rounded-full px-0.5 text-xs font-semibold ' + ('info' | badge)">Call Center</span>
            <span class="text-base font-bold text-gray-900">{{ callCenter.Open | number }}</span>
            <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
          </a>
        }
      </div>
    </div>

    <!-- 3. Tasks -->
    <div class="relative flex flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <div class="absolute inset-x-0 top-0 h-[3px] rounded-t-xl" [style.background]="'#f97316'"></div>
      <div class="flex items-center gap-2 px-4 pt-2">
        <span class="text-base font-bold text-gray-700">Tasks</span>
      </div>
      <div class="flex flex-col divide-y divide-gray-50 px-4 pb-1">
        <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/profile/my-tasks" [queryParams]="{ _ref: 'dashboard', user_id: profile?.id }">
          <mat-icon class="text-blue-400 icon-size-4" fontIcon="pending_actions"></mat-icon>
          <span class="flex-1 truncate text-sm">Open</span>
          <span class="text-base font-bold text-gray-900">{{ tasksData.Open | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
        <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/profile/my-tasks" [queryParams]="{ _ref: 'dashboard', user_id: profile?.id }">
          <mat-icon class="text-green-400 icon-size-4" fontIcon="check_circle"></mat-icon>
          <span class="flex-1 truncate text-sm">Resolved</span>
          <span class="text-base font-bold text-gray-900">{{ tasksData.Resolved | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
      </div>
    </div>

    <!-- 4. Accounting -->
    <div class="relative flex flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <div class="absolute inset-x-0 top-0 h-[3px] rounded-t-xl" [style.background]="'#4f46e5'"></div>
      <div class="flex items-center gap-2 px-4 pt-2">
        <span class="text-base font-bold text-gray-700">Accounting</span>
      </div>
      <div class="flex flex-col divide-y divide-gray-50 px-4 pb-1">
        <a
          class="flex items-center gap-2 text-gray-600 transition hover:text-primary"
          routerLink="/accounting/online-payments"
          [queryParams]="{ _ref: 'dashboard', user_id: profile?.id }"
          matTooltip="Payments that are New, Pending, On Hold, or Successful but without a receipt yet"
          matTooltipPosition="above"
        >
          <mat-icon class="text-blue-400 icon-size-4" fontIcon="pending"></mat-icon>
          <span class="flex-1 truncate text-sm">Open Payments</span>
          <span class="text-base font-bold text-gray-900">{{ incomingPaymentsData.Open | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
        <a
          class="flex items-center gap-2 text-gray-600 transition hover:text-primary"
          routerLink="/accounting/online-payments"
          [queryParams]="{ _ref: 'dashboard', user_id: profile?.id }"
          matTooltip="Payments that are Unsuccessful, Cancelled, Declined, Not Paid, or Rejected, plus New payments with a receipt already attached"
          matTooltipPosition="above"
        >
          <mat-icon class="text-green-400 icon-size-4" fontIcon="check_circle"></mat-icon>
          <span class="flex-1 truncate text-sm">Resolved Payments</span>
          <span class="text-base font-bold text-gray-900">{{ incomingPaymentsData.Resolved | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
        <a
          class="flex items-center gap-2 text-gray-600 transition hover:text-primary"
          routerLink="/accounting/bills"
          [queryParams]="{ _ref: 'dashboard', user_id: profile?.id }"
          matTooltip="Total bills assigned to me, in any status, for the selected period"
          matTooltipPosition="above"
        >
          <mat-icon class="text-red-400 icon-size-4" fontIcon="receipt_long"></mat-icon>
          <span class="flex-1 truncate text-sm">Vendor Bills</span>
          <span class="text-base font-bold text-gray-900">{{ vendorBills | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
      </div>
    </div>

    <!-- 5. Procurement -->
    <div class="relative flex flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <div class="absolute inset-x-0 top-0 h-[3px] rounded-t-xl" [style.background]="'#0d9488'"></div>
      <div class="flex items-center gap-2 px-4 pt-2">
        <span class="text-base font-bold text-gray-700">Procurement</span>
      </div>
      <div class="flex flex-col divide-y divide-gray-50 px-4 pb-1">
        <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/procurement/work-orders/inbox">
          <mat-icon class="text-teal-500 icon-size-4" fontIcon="construction"></mat-icon>
          <span class="flex-1 truncate text-sm">Work Orders</span>
          <span class="text-base font-bold text-gray-900">{{ workOrders | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
        <a class="flex items-center gap-2 text-gray-600 transition hover:text-primary" routerLink="/procurement/rfps/inbox">
          <mat-icon class="text-amber-500 icon-size-4" fontIcon="work"></mat-icon>
          <span class="flex-1 truncate text-sm">RFPs</span>
          <span class="text-base font-bold text-gray-900">{{ rfps | number }}</span>
          <mat-icon class="opacity-40 icon-size-4" fontIcon="chevron_right"></mat-icon>
        </a>
      </div>
    </div>
  </div>
}
